/* -----------------Globals--------------- */
import type { Editor } from "@tiptap/react";
import { create } from "zustand";

type State = {
	editorRef: Editor | undefined;
	setEditorRef: (ref: Editor) => void;
	resetEditorStore: () => void;
};

const useEditorStore = create<State>()((set) => ({
	editorRef: undefined,
	setEditorRef: (ref: Editor) => set({ editorRef: ref }),
	resetEditorStore: () => set({ editorRef: undefined }),
}));

export default useEditorStore;
